<template>
    <div class="admin-container">
        <StudentHeaderModule></StudentHeaderModule>
        <div class="student-wrapper">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import StudentHeaderModule from '../components/header/StudentHeaderModule.vue'
    export default {
        name: "StudentLayout",
        components: {
            StudentHeaderModule
        }
    }
</script>

<style scoped >

</style>